import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <footer className="bg-pink-beige border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* スマホ版：ロゴをアコーディオンボタンに */}
        <div className="md:hidden">
          <div className="flex justify-center items-center py-12 relative">
            {/* 中央ロゴ - アコーディオンボタン */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
              <button 
                onClick={() => setIsOpen(!isOpen)}
                className="transition-all duration-200 active:scale-95"
              >
                <div className="bg-pink-beige rounded-full w-24 h-24 flex items-center justify-center relative">
                  <div className="absolute top-0 left-0 w-full h-1/2 border-2 border-white border-b-0 rounded-t-full"></div>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                    alt="SrWith"
                    className="h-14 w-auto filter brightness-0 invert"
                  />
                  {/* タップヒント - 上矢印 */}
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                    <div className={`text-gray-600 text-sm transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                      ▲
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
          
          {/* アコーディオンコンテンツ */}
          {isOpen && (
            <div className="pt-2 pb-6 -mt-14 relative z-50">

              <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm mb-4">
                <Link to="/" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>トップ</Link>
                <Link to="/service" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>サービス紹介</Link>
                <Link to="/philosophy" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>理念・代表の思い</Link>
                <Link to="/partner" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>パートナー社労士</Link>
                <Link to="/download" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>資料ダウンロード</Link>
                <Link to="/contact" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>お問い合わせ</Link>
                <Link to="/lp/academy" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>SrWithアカデミー</Link>
                <Link to="/privacy" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>プライバシーポリシー</Link>
                <Link to="/lp/academy/cancellation-policy" className="text-white hover:text-gray-200 transition-colors duration-200" onClick={() => setIsOpen(false)}>キャンセルポリシー</Link>
              </div>

              <div className="border-t border-white/20 pt-3">
                <div className="text-center text-white text-xs">
                  <p className="mb-1">© 2025 SrWith株式会社. All rights reserved.</p>
                  <p>〒847-0054 佐賀県唐津市西寺町1-27-27</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* PC版：従来のデザイン */}
        <div className="hidden md:block">
          <div className="flex justify-center items-center py-3 relative">
            {/* 中央ロゴ - ボーダーライン上に配置（ヘッダーと同じ位置） */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
              <Link to="/" className="hover:opacity-80 transition-all duration-200">
                <div className="bg-pink-beige rounded-full w-24 h-24 flex items-center justify-center relative">
                  <div className="absolute top-0 left-0 w-full h-1/2 border-2 border-white border-b-0 rounded-t-full"></div>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                    alt="SrWith"
                    className="h-14 w-auto filter brightness-0 invert"
                  />
                </div>
              </Link>
            </div>
          </div>
          
          {/* サイトマップ */}
          <div className="pt-8 pb-4">
            <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm">
              <Link to="/" className="text-white hover:text-gray-200 transition-colors duration-200">トップ</Link>
              <Link to="/service" className="text-white hover:text-gray-200 transition-colors duration-200">サービス紹介</Link>
              <Link to="/philosophy" className="text-white hover:text-gray-200 transition-colors duration-200">理念・代表の思い</Link>
              <Link to="/partner" className="text-white hover:text-gray-200 transition-colors duration-200">パートナー社労士</Link>
              <Link to="/download" className="text-white hover:text-gray-200 transition-colors duration-200">資料ダウンロード</Link>
              <Link to="/contact" className="text-white hover:text-gray-200 transition-colors duration-200">お問い合わせ</Link>
              <Link to="/lp/academy" className="text-white hover:text-gray-200 transition-colors duration-200">SrWithアカデミー</Link>
              <Link to="/privacy" className="text-white hover:text-gray-200 transition-colors duration-200">プライバシーポリシー</Link>
              <Link to="/lp/academy/cancellation-policy" className="text-white hover:text-gray-200 transition-colors duration-200">キャンセルポリシー</Link>
            </div>
          </div>

          {/* 会社情報 */}
          <div className="border-t border-white/20 pt-4 pb-6 mt-4">
            <div className="text-center text-white text-xs">
              <p className="mb-2">© 2025 SrWith株式会社. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;